import { Box, Container, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import "react-calendar/dist/Calendar.css";
import AllSalesTab from "../components/reports/AllSalesTab";
import ProductSalesTab from "../components/reports/ProductSalesTab";
import SalesByDateTab from "../components/reports/SalesByDateTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ReportsPage() {
  const [tabValue, setTabValue] = useState(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleViewAllSales = (date: Date) => {
    // Switch to All Sales tab
    setTabValue(0);
    // You'll need to pass this date to AllSalesTab somehow
    // One way is to lift the date state up to ReportsPage
    setStartDate(date);
    setEndDate(date);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}>
          <Tab label="All Sales" />
          <Tab label="Sales by Date" />
          <Tab label="Products" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <AllSalesTab startDateToSet={startDate} endDateToSet={endDate} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <SalesByDateTab onViewAllSales={handleViewAllSales} />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <ProductSalesTab />
      </TabPanel>
    </Container>
  );
}
